module.exports = __webpack_public_path__ + "static/media/Strahl18000FR14.e14e78c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/stores/presets/photos/Strahl18000FR14.jpg
// module id = 158
// module chunks = 0